/* eslint-disable */
import React, { useMemo, useState } from 'react';

import { CTitle, STitle, WTitle } from '../../components/Widget';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import Quiz from '../../components/Quiz';
import ArrowImg from '../../../../../../assets/2025/arrow.gif';
import Icon1 from '../../../../../../assets/education/ot/icon/icon1.png';
import Icon2 from '../../../../../../assets/education/ot/icon/icon2.png';
import Icon3 from '../../../../../../assets/education/ot/icon/icon3.png';
import Icon4 from '../../../../../../assets/education/ot/icon/icon4.png';
import Icon5 from '../../../../../../assets/education/ot/icon/icon5.png';
import Icon6 from '../../../../../../assets/education/ot/icon/icon6.png';
import Img1 from '../../../../../../assets/education/ot/picture/img1.png';
import Img2 from '../../../../../../assets/education/ot/picture/img2.png';
import Img3 from '../../../../../../assets/education/ot/picture/img3.png';
import Img4 from '../../../../../../assets/education/ot/picture/img4.png';
import Img5 from '../../../../../../assets/education/ot/picture/img5.png';
import Img6 from '../../../../../../assets/education/ot/picture/img6.png';
import { Collapse } from 'antd';
import { useUpdateComponentState } from '../../../hooks';
import { CaretRightOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
const { Panel } = Collapse;
interface ISection0Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const { quiz } = paragraphsSettings;
  const { updateParagraphState } = useStore();
  const [quizState, setQuizState] = useState(false);
  const quizComplete = () => {
    setQuizState(true);
  };
  const [state, setState] = useState({
    deepfakeFlag: false,
    deepfakeFlag2: false,
  });
  const [checked, setChecked] = useState<any>([]);
  const [activeArr, setActiveArr] = useState([0,1,2,3,4,5]);
  const [active,setActive] = useState<any>(0);
  const numToImg = (num: number) => {
    return{
      0:Img1,
      1:Img2,
      2:Img3,
      3:Img4,
      4:Img5,
      5:Img6,
    }[num]
  };
  const numToIcon = (num: number) => {
    return{
      0:Icon1,
      1:Icon2,
      2:Icon3,
      3:Icon4,
      4:Icon5,
      5:Icon6,
    }[num]
  };
  const getArrayMin = (arr: any,value:any) => {
    const newArr = arr.filter((item:any) => item !== value)
    setActiveArr([...newArr])
    if (!Array.isArray(newArr) || newArr.length === 0) return null;
    return Math.min(...newArr);
  };
  React.useEffect(() => {
    if (quizState) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'education-ot-section2-question'
      );
    }
  }, [p_course, p_topic, quizState]);

  // React.useEffect(() => {
  //   if (state.deepfakeFlag) {
  //     updateComponentState(p_course, p_topic, ID, '2025-topic1600-section2-1');
  //   }
  // }, [p_course, p_topic, state.deepfakeFlag]);

  React.useEffect(() => {
    if (state.deepfakeFlag&&state.deepfakeFlag2) {
      updateComponentState(p_course, p_topic, ID, 'education-ot-section2-1');
    }
  }, [p_course, p_topic, state]);
  const changeTab = (key:any) =>{
     if(!checked.includes(key)){
       const newChecked = [...checked, key];
       setChecked(newChecked);
       if (newChecked.length>=6){
         updateComponentState(p_course, p_topic, ID, 'education-ot-section2-2');
       }
       const min = getArrayMin(activeArr,Number(key))
       setActive(min)
       console.log(newChecked,min,'============newChecked')
     }
  }
  return (
    <div className="topic-section-2">
      <CTitle title={paragraphsSettings?.toolTitle} />
      <div className="tools">
        <STitle title={paragraphsSettings?.toolTitle} />
        <div className="tools-box" id="education-ot-section2-1">
          <div
            className="tools-left"
            onClick={() => setState({ ...state, deepfakeFlag: true })}
          >
            {!state.deepfakeFlag && <img src={ArrowImg} alt="" />}
            {state.deepfakeFlag && (
              <span className="focus-in-expand-fwd">
                {paragraphsSettings?.l3}
              </span>
            )}
          </div>
          <div
            className="tools-right"
            onClick={() => setState({ ...state, deepfakeFlag2: true })}
          >
            {!state.deepfakeFlag2 && <img src={ArrowImg} alt="" />}
            {state.deepfakeFlag2 && (
              <span className="focus-in-expand-fwd">
                {paragraphsSettings?.l4}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="visit">
        <STitle title={paragraphsSettings?.visitTitle} />
        <div className="visit-tips" id="education-ot-section2-2">
          <CaretRightOutlined
            style={{ color: '#837DFF', fontSize: '1.5rem' }}
          />
          {paragraphsSettings?.visitTips}
        </div>
        <Collapse
          expandIcon={({ isActive }) =>
            isActive ? (
              <MinusOutlined
                style={{ color: '#FFFFFF', fontSize: '1.75rem' }}
              />
            ) : (
              <PlusOutlined style={{ color: '#FFFFFF', fontSize: '1.75rem' }} />
            )
          }
          accordion
          onChange={(key) => changeTab(key)}
        >
          {paragraphsSettings?.visitList.map((item: any, index: number) => (
            <Panel
              header={
                <>
                  {active == index && (
                    <img className="arrow-img" src={ArrowImg} alt="" />
                  )}
                  {item}
                  <img src={numToIcon(index)} alt="" />
                </>
              }
              key={index}
            >
              <img src={numToImg(index)} alt="" />
            </Panel>
          ))}
        </Collapse>
      </div>
      <div className="guide">
        <STitle title={paragraphsSettings?.guideTitle} />
        <div className="guide-tips">
          <CaretRightOutlined
            style={{ color: '#837DFF', fontSize: '1.5rem' }}
          />
          {paragraphsSettings?.guideTips}
        </div>
        <div className="guide-content">
          {paragraphsSettings?.guideList.map((item: any, index: number) => (
            <div key={index} className={`guide-item guide-item-${index + 1}`}>
              {item}
            </div>
          ))}
          {paragraphsSettings?.guideContent}
        </div>
      </div>
      <div id="education-ot-section2-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={quizComplete}
        />
      </div>
    </div>
  );
};

export default React.memo(Section2);
